<template>
  <v-app id="inspire">
    <Header type="search"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>
          <Menu/>
          <v-container class="col-10">
            <v-row>
              <v-col
                  class="page-top d-flex justify-space-between"
                  cols="12"
              >
                <div>
                  <div class="page-title">{{ service_type === 0 ? 'Персональное занятие' : 'Групповое занятие' }}</div>
                  <div class="breadcrumb"><span class="breadcrumb-bold">Расписание /</span> {{ service_type === 0 ? 'Персональное занятие' : 'Групповое занятие' }}</div>
                </div>
                <div>
                  <v-skeleton-loader
                      v-if="isLoading"
                      type="actions"
                  >
                  </v-skeleton-loader>
                  <v-btn
                      v-else
                      color="#629F33"
                      class="button__success"
                      @click="createLesson"
                  >
                    Создать занятие
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12">
                <v-sheet class="rounded-lg card">
                  <v-menu
                      top
                      right
                      offset-y
                      rounded="lg"
                      content-class="custom__menu"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          class="button__lighten ml-3"
                          v-bind="attrs"
                          v-on="on"
                      >
                        <img src="/playground_assets/printer-logo.svg" class="mr-1" alt="">
                        Печать
                      </v-btn>
                    </template>

                    <v-list>
                      <v-list-item>
                        <v-list-item-title style="cursor: pointer">Акт о выполненных работах</v-list-item-title>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title style="cursor: pointer">Реестр посещения</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-skeleton-loader
                    v-if="isLoading"
                    type="article"
                  ></v-skeleton-loader>
                  <v-row v-else style="padding: 20px 20px 0 20px">
                    <v-col
                        md="5"
                    >
                      <label>Услуга</label>

                      <v-select
                          v-if="service && service.service && service.service.name && noservice === false"
                          v-model="service.service.name"
                          class="rounded-lg custom__select"
                          :items="[service.service.name]"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          color="#629F33"
                          label="Выбрать"
                          append-icon="mdi-chevron-down"
                          outlined
                          dense
                          required
                          readonly
                          style="height: 48px;margin-top: 10px"
                      ></v-select>
                      <v-select
                          v-else
                          v-model="serviceNew"
                          class="rounded-lg custom__select"
                          :items="serviceItems"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          item-text="name"
                          item-value="service_id"
                          color="#629F33"
                          label="Выбрать"
                          append-icon="mdi-chevron-down"
                          outlined
                          dense
                          required
                          @change="getNewPositions"
                          return-object
                          style="height: 48px;margin-top: 10px"
                      ></v-select>
                    </v-col>
                    <v-col
                        md="5"
                    >
                      <div style="display: flex; flex-direction: column;">
                        <label>Сотрудник</label>
                        <div style="display: flex; align-items: center;">
                          <div class="check-div">
                                    <v-checkbox
                                        color="#629F33"
                                        v-model="position_checked"
                                    ></v-checkbox>
                                  </div>
                          <div>Отбор ограничен параметрами</div>
                        </div>
                      </div>
                      <div v-if="position_checked">
                        <v-select
                          v-if="position_list"
                          class="rounded-lg custom__select"
                          v-model="lesson_position"
                          :items="position_list"
                          item-value="id"
                          item-text="name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          color="#629F33"
                          label="Должности"
                          append-icon="mdi-chevron-down"
                          outlined
                          dense
                          hint="Выберите должности"
                          multiple
                          persistent-hint
                          style="margin-bottom: 10px"

                      >
                        <template v-slot:prepend-inner>
                          <div class="logo-bg mr-2">
                            <img src="/playground_assets/users.svg" alt="">
                          </div>
                        </template>
                      </v-select>
                      </div>
                      <v-select
                          v-if="specialist_list"
                          class="rounded-lg custom__select"
                          v-model="lesson_specialist"
                          :items="specialist_list"
                          item-value="id"
                          item-text="name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          color="#629F33"
                          label="Выбрать"
                          append-icon="mdi-chevron-down"
                          outlined
                          dense
                          required
                          style="height: 48px;margin-top: 10px"
                      >
                        <template v-slot:prepend-inner>
                          <div class="logo-bg mr-2">
                            <img src="/playground_assets/users.svg" alt="">
                          </div>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col
                        md="2"
                    >
                      <label>Помещение</label>
                      <v-select
                          v-if="service && service.service && service.service.room"
                          v-model="service.service.room.id"
                          class="rounded-lg custom__select"
                          :items="room.room"
                          item-value="id"
                          item-text="name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          color="#629F33"
                          label="Выбрать"
                          append-icon="mdi-chevron-down"
                          outlined
                          dense
                          required
                          style="height: 48px;margin-top: 10px"
                      ></v-select>
                      <v-select
                          v-else
                          v-model="room.room[0]"
                          class="rounded-lg custom__select"
                          :items="room.room"
                          item-value="id"
                          item-text="name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          color="#629F33"
                          label="Выбрать"
                          append-icon="mdi-chevron-down"
                          outlined
                          dense
                          required
                          style="height: 48px;margin-top: 10px"
                      ></v-select>
                    </v-col>
                    <v-col
                        md="3"
                    >
                      <label>Дата</label>
                      <template>
                        <VueDatePicker
                            no-title
                            no-header
                            color="#629f34"
                            v-model="lesson_date"
                            placeholder="Дата"
                        >
                          <template #activator="{ date }">
                            <button
                                class="button custom__datepicker"
                                ref="activator"
                                type="button"
                            >
                              <div>
                                <span v-if="date">{{ date }}</span>
                                <span v-else style="color: gray">Дата</span>
                              </div>
                              <div>
                                <v-icon
                                    medium
                                    right
                                    class="ml-5"
                                >
                                  mdi-calendar-blank-outline
                                </v-icon>
                              </div>
                            </button>
                          </template>
                        </VueDatePicker>
                      </template>
                    </v-col>
                    <v-col
                        md="3"
                    >
                      <label>Начало</label>
                      <v-select
                          v-if="!lesson_starttime"
                          v-model="lesson_starttime"
                          class="rounded-lg custom__select"
                          :items="start_time"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          color="#629F33"
                          append-icon="mdi-chevron-down"
                          outlined
                          dense
                          required
                          style="height: 48px;margin-top: 10px"
                      >
                      </v-select>
                      <v-text-field
                          v-else
                          v-model="lesson_starttime"
                          class="rounded-lg"
                          outlined
                          dense
                          required
                          style="height: 48px;margin-top: 10px"
                      >
                    </v-text-field>
                    </v-col>
                    <v-col
                        md="3"
                    >
                      <label>Продолжительность</label>
                      <v-text-field
                          class="rounded-lg"
                          outlined
                          dense
                          required
                          :value="((service && service.service && service.service.duration) ? service.service.duration : 30) + ' мин'"
                          readonly
                          style="height: 48px;margin-top: 10px"
                      >
                        <template v-slot:append>
                          <v-btn-toggle style="margin-right: -12px" class="rounded-r-lg no-active__toggle">
                            <v-btn @click="downDuration" style="padding: 0 !important; min-width: 38px !important; margin-top: -8px;">
                              <v-icon>mdi-chevron-down</v-icon>
                            </v-btn>
                            <v-btn @click="upDuration" style="padding: 0 !important; min-width: 38px !important; margin-top: -8px;">
                              <v-icon>mdi-chevron-up</v-icon>
                            </v-btn>
                          </v-btn-toggle>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col
                        md="3"
                    >
                      <v-btn-toggle
                          :value="service.service.duration === 60 ? 1 : 0"
                          mandatory
                          class="rounded-lg"
                          style="margin-top: 33px;"
                      >
                        <v-btn style="background-color: #FFF !important;" @click="service.service.duration = 30">
                          30 мин
                        </v-btn>
                        <v-btn style="background-color: #FFF !important;" @click="service.service.duration = 60">
                          60 мин
                        </v-btn>
                      </v-btn-toggle>
                    </v-col>
                    <v-col md="5">
                      <v-btn-toggle
                          v-model="lesson_status"
                          mandatory
                          class="rounded-lg"
                          style="margin-top: 35px;"
                      >
                        <v-btn style="padding: 12px 20px !important; background-color: #fff !important;">
                          Запланировано
                        </v-btn>
                        <v-btn style="padding: 12px 20px !important; background-color: #fff !important;">
                          Выполнено
                        </v-btn>
                      </v-btn-toggle>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col>
              <v-col cols="12">
                <v-data-table
                    :headers="headersSuccessLessons"
                    :items="successLessons"
                    no-data-text="Нет записанных клиентов"
                    :hide-default-footer="true"
                >
                  <template v-slot:item.product="{ item }">
                    {{ item.product.name ? item.product.name : item.product.product }}
                  </template>
                  <template v-slot:item.arrival_status="{ item }">
                    <v-select
                        class="rounded-lg table__select"
                        v-model="item.arrival_status"
                        :items="statusTypes"
                        item-value="type_id"
                        item-text="type_name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        append-icon="mdi-chevron-down"
                        outlined
                        dense
                        required
                        style="height: 48px;margin-top: 10px"
                    >
                    </v-select>
                  </template>
                  <template v-if="client_list.length === 0" v-slot:body.append>
                    <tr>
                      <td colspan="1" class="text-start">

                        <v-autocomplete
                            v-if="service_type === 1"
                            class="rounded-lg table__select"
                            :items="listClient ? listClient.client : []"
                            item-value="client_id"
                            item-text="name"
                            :menu-props="{ top: true, offsetY: true, rounded: 'lg' }"
                            label="Добавить клиента"
                            append-icon="mdi-chevron-down"
                            no-data-text="Результатов не найдено"
                            :search-input.sync="search_client"
                            v-model="select_client"
                            hide-details
                            outlined
                            dense
                            color="#629F33"
                            style="height: 48px;padding-top: 5px;"
                        >
                          <template v-slot:prepend-inner>
                            <div class="logo-bg mr-2">
                              <img src="/playground_assets/users.svg" alt="">
                            </div>
                          </template>
                        </v-autocomplete>
                        <span v-else-if="select_client && select_client !== null && select_client !== 'null'">{{ search_client }}</span>
                      </td>
                      <td
                          colspan="1"
                          class="text-start"
                          v-if="reason && select_client && select_client !== null && select_client !== 'null'"
                      >
                        <v-select
                            class="rounded-lg table__select"
                            label="Выбрать основание"
                            v-model="select_reason"
                            :items="reason.reason"
                            item-value="id"
                            item-text="name"
                            :menu-props="{ top: true, offsetY: true, rounded: 'lg' }"
                            append-icon="mdi-chevron-down"
                            outlined
                            dense
                            required
                            style="height: 48px;margin-top: 10px"
                        >
                          <template v-slot:no-data>
                            <v-list-item>
                              <!--                                    <v-list-item-content v-if="lesson.lesson.service.available" @click="dialogCreateSale = true" style="cursor: pointer">-->
                              <!--                                      <v-list-item-title class="sale-service_text">-->
                              <!--                                        <span>Продать услугу: <span style="color: #000"> {{ lesson.lesson.service.name }} -</span> {{ lesson.lesson.service.price }} ₽ ({{ lesson.lesson.service.price_type.name }})</span>-->
                              <!--                                      </v-list-item-title>-->
                              <!--                                    </v-list-item-content>-->
                              <v-list-item-content style="cursor: pointer">
                                <v-list-item-title class="sale-service_text">
                                  <span>Продать услугу: <span style="color: #D53025"> Нет доступных </span></span>
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-select>
                      </td>
                      <td
                          colspan="1"
                          class="text-start"
                          v-if="select_reason"
                      >
                        <v-select
                            class="rounded-lg table__select"
                            v-model="select_status"
                            :items="statusTypes"
                            item-value="type_id"
                            item-text="type_name"
                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                            append-icon="mdi-chevron-down"
                            outlined
                            dense
                            required
                            style="height: 48px;margin-top: 10px"
                        >
                        </v-select>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
        <v-row justify="center">
          <v-dialog
              v-model="dialogCreateSale"
              persistent
              max-width="400px"
          >
            <v-card>
              <v-card-title class="text-center">
                <v-spacer></v-spacer>
                <v-btn icon @click="dialogCreateSale = false" >
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text style="padding-bottom: 30px;">
                <v-container>
                  <div>
                    <h3 class="card-title">Вы уверены, что хотите создать продажу?</h3>
                  </div>
                  <v-row
                      align="center"
                      class="mt-5 justify-center"
                  >
                    <button
                        class="button button__success"
                        ref="activator"
                        type="button"
                        @click="createSale"
                    >
                      Да
                    </button>
                    <button
                        class="button button__secondary ml-5"
                        ref="activator"
                        type="button"
                        @click="dialogCreateSale = false"
                    >
                      Нет
                    </button>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {VueDatePicker} from "@mathieustan/vue-datepicker";
import {mapState} from "vuex";
import {lessonActionTypes} from "@/store/modules/lesson";
import {clientActionTypes} from '@/store/modules/client';
import {salesActionTypes} from '@/store/modules/sale';
import {getItem} from '@/helpers/persistanceStorage';
import {setItem} from '@/helpers/persistanceStorage';
import {scheduleActionTypes} from "@/store/modules/schedule";

export default {
  name: "CreateLesson",
  props: ['service_id','service_type','lesson_specialist','search_client','select_client','lesson_date','lesson_starttime'],
  components: {
    VueDatePicker,
    Header,
    Menu
  },
  computed: {
    ...mapState({
      isLoading: state => state.lesson.isLoading,
      listClient: state => state.client.listClient,
      service: state => state.lesson.service,
      room: state => state.lesson.room,
      reason: state => state.lesson.reason,
      cancelReason: state => state.lesson.cancelReason
    }),
    successLessons() {
      return this.client_list.filter(item => item.arrival_status !== 2);
    }
  },
  data() {
    return {
      specialist_list_def:[],
      specialist_list:[],
      position_list:[],
      position_checked:false,
      lesson_position:null,
      date: null,
      lesson_status: null,
      lesson_recorded: null,
      lesson_visited: null,
      time: 0,
      dialogCreateSale: false,
      status: 0,
      statusTypes: [
        {type_id: 0, type_name: 'Не прибыл'},
        {type_id: 1, type_name: 'Прибыл'}
      ],
      select_reason: null,
      select_cancelReason: null,
      select_sale: null,
      select_status: {type_id: 0, type_name: 'Не прибыл'},
      toggle_status: null,
      start_time: [
        '07:00','07:15','07:30','07:45','08:00','08:15','08:30','08:45','09:00','09:15','09:30','09:45','10:00','10:15','10:30','10:45','11:00','11:15','11:30','11:15',
        '12:00','12:15','12:30','12:45','13:00','13:15','13:30','13:45','14:00','14:15','14:30','14:45','15:00','15:15','15:30','15:45','16:00','16:15','16:30','16:45',
        '17:00','17:15','17:30','17:45','18:00','18:15','18:30','18:45','19:00','19:15','19:30','19:45','20:00','20:15','20:30','20:45','21:00','21:15','21:30','21:45','22:00'
      ],
      client_list: [],
      lesson_tab: null,
      lessons: [
        {tab: 'Состав занятия'},
        {tab: 'Отменённые клиенты'}
      ],
      headersSuccessLessons: [
        {text: 'Клиент', align: 'start', sortable: false, value: 'client.fio', width: '30%'},
        {text: 'Основание', sortable: false, value: 'product', width: '30%'},
        {text: 'Статус прибытия клиента', sortable: false, value: 'arrival_status', width: '30%'}
      ],
      months: [
        'января',
        'февраля',
        'марта',
        'апреля',
        'мая',
        'июня',
        'июля',
        'августа',
        'сентября',
        'октября',
        'ноября',
        'декабря'
      ],
      serviceItems:[],
      serviceNew: null,
      noservice:false
    }
  },
  methods: {
    getNewPositions(){
      console.log(this.service)
      console.log(this.serviceNew)
      this.service_id = this.serviceNew.service_id
      //this.select_client !== undefined ? setItem('schedule-select_client', this.select_client) : this.select_client = getItem('schedule-select_client');
      this.$store.dispatch(lessonActionTypes.getReasonList, {
          client_id: this.select_client ? this.select_client : null,
          service_id: this.service_id
        }).then((resp) => {
          console.log(resp)
          this.select_reason = resp.reason[0]
        });
    },
    fetchFeed(service_id, search_client, select_client) {
      console.log(this.service_id)
      if(this.service_id && this.service_id !== undefined && this.service_id !== null && this.service_id !== "null"){
        this.$store.dispatch(lessonActionTypes.getServiceInfo, { service_id });
        this.$store.dispatch(lessonActionTypes.getRoomList, {
          for_lesson: true
        });
        this.$store.dispatch(clientActionTypes.searchClient, {
          client_field: search_client
        });
        this.$store.dispatch(lessonActionTypes.getReasonList, {
          client_id: select_client,
          service_id: service_id
        }).then((resp) => {
          console.log(resp)
          this.select_reason = resp.reason[0]
        });
        this.$store.dispatch(lessonActionTypes.getPositionList, {
          client_id: select_client,
          service_id: service_id
        }).then((resp) => {
          this.position_list = resp.position
        });
        this.$store.dispatch(lessonActionTypes.getSpecialistList, {
          client_id: select_client,
          service_id: service_id
        }).then((resp) => {
          //"48830ace-00d9-11ec-a060-60e32700ce56"

          if(resp && resp.specialist && resp.specialist.length > 0){
            this.specialist_list = resp.specialist
            this.specialist_list_def = resp.specialist
          } else {
            this.$store.dispatch(lessonActionTypes.getSpecialistList, {
              }).then((resp) => {
                //"48830ace-00d9-11ec-a060-60e32700ce56"

                if(resp && resp.specialist && resp.specialist.length > 0){
                  this.specialist_list = resp.specialist
                  this.specialist_list_def = resp.specialist
                } else {
                    alert('Список специалистов не найден')
                }

              });
          }

        });

        setItem('schedule-no_service', false)

        this.noservice = false

      } else {

        

        this.$store.dispatch(lessonActionTypes.getRoomList, {
          for_lesson: true
        });
        this.$store.dispatch(clientActionTypes.searchClient, {
          client_field: search_client
        });
 
        this.$store.dispatch(lessonActionTypes.getPositionList, {
          client_id: select_client,
          service_id: service_id
        }).then((resp) => {
          this.position_list = resp.position
        });

        this.$store.dispatch(lessonActionTypes.getSpecialistList, {
          client_id: select_client,
          service_id: service_id
        }).then((resp) => {
          //"48830ace-00d9-11ec-a060-60e32700ce56"

          if(resp && resp.specialist && resp.specialist.length > 0){
            this.specialist_list = resp.specialist
            this.specialist_list_def = resp.specialist
          } else {
            this.$store.dispatch(lessonActionTypes.getSpecialistList, {
              }).then((resp) => {
                //"48830ace-00d9-11ec-a060-60e32700ce56"

                if(resp && resp.specialist && resp.specialist.length > 0){
                  this.specialist_list = resp.specialist
                  this.specialist_list_def = resp.specialist
                } else {
                    alert('Список специалистов не найден')
                }

              });
          }

        });

        this.$store.dispatch(scheduleActionTypes.getSchedule, {
          start_date: this.lesson_date,
          end_date: this.lesson_date
        }).then((response) => {

          if(this.service_type === 0) {
            this.serviceItems = response.schedule?.group
          } else {
            this.serviceItems = response.schedule?.indiv
          }
          

        })

        this.service = null

        setItem('schedule-no_service', true)

        this.noservice = true

        console.log(this.service)

      }
 
    },
    downDuration() {
      if (this.service.service.duration !== 0) {
        this.service.service.duration--;
      }
    },
    upDuration() {
      if (this.service.service.duration !== 60) {
        this.service.service.duration++;
      }
    },
    downCapacity() {
      if (this.lesson_capacity !== 0) {
        this.lesson_capacity--;
      }
    },
    upCapacity() {
      if (this.lesson_capacity !== 10) {
        this.lesson_capacity++;
      }
    },
    createSale() {
      this.$store.dispatch(salesActionTypes.createSale, {
        client_id: this.select_client,
        service_list: [
          {
            service_id: this.lesson.lesson.service.id,
            name: this.lesson.lesson.service.name,
            count: 1,
            price: this.lesson.lesson.service.price,
            sum: this.lesson.lesson.service.price,
            specialist_id: this.lesson.lesson.specialist.id,
          }
        ]
      })
          .then(() => {
            this.$store.dispatch(lessonActionTypes.getReasonList, {
              client_id: this.select_client,
              service_id: this.lesson.lesson.service.id
            });
            this.dialogCreateSale = false;
          })
    },
    createLesson() {
      if (this.select_client !== null && this.select_reason !== null && this.select_status !== null) {
        this.client_list.push({
          client_id: this.select_client,
          arrival_status: this.select_status,
          product_id: this.select_reason.id ? this.select_reason.id : this.select_reason
        })
      }
      this.$store.dispatch(lessonActionTypes.createLesson, {
        service_id: this.service.service.id,
        room_id: this.service.service.room.id,
        type: this.service_type,
        status: this.lesson_status,
        specialist_id: this.lesson_specialist,
        startdate: this.lesson_date + 'T' + this.lesson_starttime,
        duration: this.service.service.duration,
        client_list: this.client_list
      })
          .then((response) => {
            if(response && response.success){
                //this.$router.push({ name: 'Lesson', params: { appointment_id: response.lessonCreated.appointment_id } })
                this.$router.push({ name: 'Desktop', params: { client_id: this.select_client } })
            } else {
              alert('Ошибка записи на занятие!')
            }
          })
    }
  },
  // destroyed: function(){
  //   setItem('schedule-lesson_specialist', null)
  //   setItem('schedule-lesson_date', null)
  //   setItem('schedule-lesson_starttime', null)
  //   setItem('schedule-search_client', null)
  //   setItem('schedule-select_client', null)
  // },
  mounted() {
    // console.log(this.lesson_starttime)
    // console.log(this.service.service.specialist_list)
    console.log(this.service_id)
    console.log(getItem('schedule-service'))

    console.log(this.lesson_specialist)

    setItem('schedule-was_create', true)

    this.service_id !== undefined ? setItem('schedule-service_id', this.service_id) : this.service_id = getItem('schedule-service_id');
    this.service_type !== undefined ? setItem('schedule-service_type', this.service_type) : this.service_type = getItem('schedule-service_type');
    this.lesson_specialist !== undefined ? setItem('schedule-lesson_specialist', this.lesson_specialist) : this.lesson_specialist = getItem('schedule-lesson_specialist');
    this.search_client !== undefined ? setItem('schedule-search_client', this.search_client) : this.search_client = getItem('schedule-search_client');
    this.select_client !== undefined ? setItem('schedule-select_client', this.select_client) : this.select_client = getItem('schedule-select_client');
    this.lesson_date !== undefined ? setItem('schedule-lesson_date', this.lesson_date) : this.lesson_date = getItem('schedule-lesson_date');
    this.lesson_starttime !== undefined ? setItem('schedule-lesson_starttime', this.lesson_starttime) : this.lesson_starttime = getItem('schedule-lesson_starttime');
    console.log(this.service_id)
    console.log(this.search_client)
    console.log(this.select_client)
    this.fetchFeed(this.service_id, this.search_client, this.select_client);
  },
  watch: {
    search_client() {
      if (this.select_client === null && this.search_client !== '' && this.service_type === 1) {
        this.$store.dispatch(clientActionTypes.searchClient, {
          client_field: this.search_client
        })
      }
    },
    select_client() {
      if (this.select_client !== null) {
        this.$store.dispatch(lessonActionTypes.getReasonList, {
          client_id: this.select_client,
          service_id: this.service.service.id
        });
      }
    },
    lesson_position() {

      console.log(this.lesson_position)
      
      if(this.lesson_position && this.lesson_position.length > 0) {
        let item = this.lesson_position[this.lesson_position.length-1]
        console.log(item)
        this.specialist_list = []
        for(let pos of this.specialist_list_def){
          console.log(pos)
          if(pos.position && pos.position.id ===item){
            this.specialist_list.push(pos)
          }
        }
        console.log(this.specialist_list)
      } else {
        console.log('asa')
        this.specialist_list = this.specialist_list_def
      }

    },
    position_checked(){
      console.log('checki')
      console.log(this.position_checked)
      if(this.position_checked){
        this.specialist_list = this.specialist_list_def
      }
    }
  }
}
</script>

<style scoped>
.logo-bg {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background: #F1F1F1;
  border-radius: 25px;
}
.vd-activator .custom__datepicker {
  width: 89% !important;
  height: 14px !important;
  display: flex !important;
  padding: 12px 16px !important;
  position: relative !important;
  box-sizing: content-box !important;
  align-items: center !important;
  flex-shrink: 0 !important;
  border-color: #E0E0E0 !important;
  border-style: solid !important;
  border-width: 1px !important;
  border-radius: 8px !important;
  justify-content: space-between !important;
  margin-top: 9px !important;
  background-color: #ffffff !important;
  font-size: 14px !important;
  color: #000 !important;
}
.theme--light.v-btn.v-btn--has-bg {
  background-color: #fff;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-transform: none;
}
.theme--light.v-btn--active:hover::before, .theme--light.v-btn--active::before {
  opacity: 0!important;
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 40px !important;
  min-width: 64px !important;
}
.cancel-bg {
  background: #D53025 !important;
  border-radius: 12px !important;
  width: 48px !important;
  height: 32px !important;
}
.return-bg {
  background: #629F33 !important;
  border-radius: 12px !important;
  width: 48px !important;
  height: 32px !important;
}
.time-control__button {
  border-left: 1px solid #E0E0E0;
}
.time-active {
  color: #767676 !important;
}
.sale-service_text {
  font-weight: 700 !important;
  font-size: 13px !important;
  line-height: 16px !important;
  display: flex;
  align-items: center;
  color: #767676;
}
.card-title {
  text-align: center;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: #000000;
  padding: 0 25px;
}

.custom__menu {
  max-height: 112px !important;
  max-width: 199px !important;
}
.custom__menu > .v-list > .v-list-item {
  min-height: 32px !important;
}
.custom__menu > .v-list > .v-list-item > .v-list-item__title {
  font-weight: 700 !important;
  font-size: 13px !important;
  line-height: 16px !important;
}
</style>